import { render, staticRenderFns } from "./PasswordForget.vue?vue&type=template&id=585431e2&scoped=true&"
import script from "./PasswordForget.vue?vue&type=script&lang=js&"
export * from "./PasswordForget.vue?vue&type=script&lang=js&"
import style0 from "./PasswordForget.vue?vue&type=style&index=0&id=585431e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585431e2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VContainer,VImg,VRow,VTextField})
